import { useEffect, useState } from 'react';
import type { Currency } from '../services/currencyService';
import { getStoredCurrency, markCurrencyUserSet, setStoredCurrency } from '../services/currencyService';

import { CURRENCY_CHANGED_EVENT } from '../constants';

export function useCurrency() {
  const [currency, setCurrency] = useState<Currency>(() => getStoredCurrency());

  useEffect(() => {
    const onStorage = () => setCurrency(getStoredCurrency());
    const onCustom = () => setCurrency(getStoredCurrency());

    window.addEventListener('storage', onStorage);
    window.addEventListener(CURRENCY_CHANGED_EVENT, onCustom as any);
    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener(CURRENCY_CHANGED_EVENT, onCustom as any);
    };
  }, []);

  const updateCurrency = (next: Currency) => {
    // User explicitly chose a currency
    markCurrencyUserSet();
    setStoredCurrency(next);
    setCurrency(next);
    window.dispatchEvent(new Event(CURRENCY_CHANGED_EVENT));
  };

  return { currency, setCurrency: updateCurrency };
}
